import { Paper, Stack, Typography, Chip, alpha, useTheme } from "@mui/material";
import dayjs from "dayjs";

const ActiveFilters = ({
  appliedStartDate,
  appliedEndDate,
  onClearStartDate,
  onClearEndDate,
}) => {
  const theme = useTheme();

  if (!appliedStartDate && !appliedEndDate) {
    return null;
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        mb: 2,
        border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
        borderRadius: 2,
        bgcolor: alpha(theme.palette.primary.main, 0.05),
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
        <Typography variant="caption" fontWeight="600" color="text.secondary">
          Active Filters:
        </Typography>
        {appliedStartDate && (
          <Chip
            label={`Start: ${dayjs(appliedStartDate).format("DD/MM/YYYY")}`}
            size="small"
            onDelete={onClearStartDate}
            color="primary"
            variant="outlined"
            sx={{ fontWeight: 500 }}
          />
        )}
        {appliedEndDate && (
          <Chip
            label={`End: ${dayjs(appliedEndDate).format("DD/MM/YYYY")}`}
            size="small"
            onDelete={onClearEndDate}
            color="primary"
            variant="outlined"
            sx={{ fontWeight: 500 }}
          />
        )}
      </Stack>
    </Paper>
  );
};

export default ActiveFilters;
